import React from 'react';

const Endorsements = () => (
	<div className="container main">
		<h2>추천의 말</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<div className="media endorsements">
					<div className="media-left">
						<img src={require('../../../assets/images/people/delia-rickard.jpg')} className="thumbnail"/>
					</div>
					<div className="media-body">
						<h4>Ms. Delia Rickard</h4>
						<p className="title">호주 경쟁소비자위원회(Australian Competition and Consumer Commission) 부의장</p>
						<p>
							The portal is a significant step for co-ordinated product safety across international boundaries. It
							reflects how nations are increasingly working together through the OECD’s Working Party on Consumer
							Product Safety to share information and highlight issues of common interest in consumer product safety.
							The working party was developed to progress a range of goals related to improved information sharing and
							this is an important milestone.
						</p>
					</div>
				</div>
			</div>
			<div className="col-sm-12">
				<div className="media endorsements">
					<div className="media-left">
						<img src={require('../../../assets/images/people/juliana-pereira.jpg')} className="thumbnail"/>
					</div>
					<div className="media-body">
						<h4>Ms. Juliana Pereira da Silva</h4>
						<p className="title">브라질 법무부 소비자보호국 전(前) 국장</p>
						<p>
							We sincerely welcome the <em>GlobalRecalls</em> portal, which hopefully will enhance a dialogue across jurisdictions and bring new perspectives 
							to our policies and enforcement actions not only within our borders but also in the global marketplace. We look forward to working in co-operation 
							with the OECD members, as we are confident that our joint efforts will promote better and clearer consumer and business relations in both developed 
							and developing economies around the globe.
						</p>
					</div>
				</div>
			</div>
		</div>
		<div className="row">
			<div className="col-sm-12">
				<div className="media endorsements">
					<div className="media-left">
						<img src={require('../../../assets/images/people/leona-aglukkaq.jpg')} className="thumbnail"/>
					</div>
					<div className="media-body">
						<h4>Ms. Leona Aglukkaq</h4>
						<p className="title">캐나다 보건부 전(前) 장관</p>
						<p>
							The Government of Canada is pleased to support the development of the <em>GlobalRecalls</em> 
							portal, which will enhance awareness of product safety, particularly among those who buy and 
							sell products internationally. This OECD project complements our government&#39;s ongoing efforts 
							to improve awareness of consumer product safety issues in Canada.
						</p>
					</div>
				</div>
			</div>
		</div>
		<div className="row">
			<div className="col-sm-12">
				<div className="media endorsements">
					<div className="media-left">
						<img src={require('../../../assets/images/people/rintaro-tamaki.jpg')} className="thumbnail"/>
					</div>
					<div className="media-body">
						<h4>Mr. Rintaro Tamaki</h4>
						<p className="title">OECD 부사무총장</p>
						<p>
							The <em>GlobalRecalls</em> portal is a global initiative which is very much in line with the OECD&rsquo;s 
							commitment to develop <em>better policies for better lives</em>. Consumers, businessmen, importers and retailers 
							will be able to access information on product recalls worldwide, in a timely manner. The portal also has 
							the potential to become a valuable tool for governments to help increase the speed and efficiency of enforcement 
							actions, within and across jurisdictions.
						</p>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					<div className="media endorsements">
						<div className="media-body">
							<h4>Ms. Věra Jourová</h4>
							<p className="title">유럽 연합 집행위원회 사법·소비자 및 양성평등 총국(Justice, Consumers and Gender Equality of the European Commission) 집행위원</p>
							<p>
								<iframe src="https://player.vimeo.com/video/225721241" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Endorsements ;



// WEBPACK FOOTER //
// ./src/views/static/ko/endorsements.js